var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerCaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25296 13C4.41628 13 5.07574 12.4976 5.38694 11.9608H5.47586V12.8899H7.32086V7.98279C7.32086 6.13145 5.88339 5.47075 4.11989 5.47075C1.96368 5.47075 1.04488 6.43427 0.955969 7.6318H2.80097C2.8973 7.17756 3.27519 6.85409 4.07543 6.85409C4.87567 6.85409 5.38694 7.20509 5.38694 7.9415V8.59532H3.46784C1.64507 8.59532 0.666992 9.46249 0.666992 10.7701C0.666992 12.1466 1.71916 13 3.25296 13ZM3.89019 11.6648C3.22332 11.6648 2.60832 11.3345 2.60832 10.6531C2.60832 10.0957 3.01585 9.68961 3.88278 9.68961H5.38694V10.4467C5.38694 11.1555 4.71266 11.6648 3.89019 11.6648Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3772 12.9862C14.2222 12.9862 15.3337 11.7612 15.3337 9.7309V8.73985C15.3337 6.70957 14.2296 5.4914 12.4068 5.4914C11.2806 5.4914 10.3914 5.98004 10.1321 6.74398H10.0358V3H8.07961V12.8899H10.0061V11.7749H10.1024C10.4211 12.5251 11.2806 12.9862 12.3772 12.9862ZM11.7252 11.5409C10.7249 11.5409 10.0358 10.8114 10.0358 9.73778V8.82932C10.0358 7.66621 10.673 6.93668 11.7029 6.93668C12.7403 6.93668 13.3331 7.66621 13.3331 8.93255V9.56573C13.3331 10.8183 12.7477 11.5409 11.7252 11.5409Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerCaseIcon);
export default __webpack_public_path__ + "static/media/lowerCaseIcon.7c67c0b74b3c2e56b542696e838295ee.svg";
export { ForwardRef as ReactComponent };